<template>
  <!-- Material 3 top app bar: the screen's title and actions in one bar -->
  <v-toolbar color="background" class="page-bar">
    <v-btn
      v-if="back"
      icon="mdi-arrow-left"
      aria-label="Back"
      @click="$emit('back')"
    />
    <v-toolbar-title v-if="title" tag="h1" class="text-title-large">
      {{ title }}
    </v-toolbar-title>
    <v-spacer v-else />
    <slot />
  </v-toolbar>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'PageBar',
    props: {
      title: { type: String, default: '' },
      // Only screens reached from another screen (not the main destinations)
      back: { type: Boolean, default: false },
    },
    emits: { back: () => true },
  });
</script>

<style scoped>
  .page-bar {
    position: sticky;
    top: 0;
    z-index: 2;
  }
</style>
